import { OrderLineItem } from '@typeDefinitions/lineItemTypes';
import { ILoadEditViewModel } from '@typeDefinitions/loadTypes';
import { IOrderViewModel } from '@typeDefinitions/orderTypes';

export const DEFAULT_NEW_ORDER_LINE_ITEM = {
  operationType: 'Insert' as const,
  quantity: 1,
  type: 'Line Haul',
  description: '',
  id: 0,
  estimate: false,
  readOnly: false,
  synched: false,
  adjustment: false,
} as const;

export const NEW_LINE_ITEM = {
  operationType: 'Insert',
  quantity: 1,
  type: '',
  description: '',
  rate: 0,
  //remove all not required once
  id: 0,
  estimate: false,
  readOnly: false,
  synched: false,
  adjustment: false,
  stopId: null,
} as unknown as OrderLineItem;

export const lineItemsTypesForCustomerPay = [
  {
    label: 'Pricing',
    value: 'Pricing',
    disabled: true,
  },
  { label: 'Line Haul', value: 'Line Haul' },
  { label: 'Rate per Mile', value: 'Rate per Mile' },
  { label: 'Rate per Pound', value: 'Rate per Pound' },
  { label: 'Rate per Unit', value: 'Rate per Unit' },
  { label: 'Spot Charge', value: 'Spot Charge' },
  {
    label: 'Accessorials',
    value: 'Accessorials',
    disabled: true,
  },
  { label: 'Accessorial', value: 'Accessorial' },
  { label: 'Bucket Truck', value: 'Bucket Truck' },
  { label: 'Damage', value: 'Damage' },
  { label: 'Dead Head', value: 'Dead Head' },
  { label: 'Detention', value: 'Detention' },
  { label: 'Detention Loading', value: 'Detention Loading' },
  { label: 'Detention Unloading', value: 'Detention Unloading' },
  { label: 'Driver Assist', value: 'Driver Assist' },
  { label: 'Fuel', value: 'Fuel' },
  { label: 'Fumigation', value: 'Fumigation' },
  { label: 'Layover', value: 'Layover' },
  { label: 'Lumper', value: 'Lumper' },
  { label: 'Lumper Loading', value: 'Lumper Loading' },
  { label: 'Lumper Unloading', value: 'Lumper Unloading' },
  { label: 'Out of Route Miles', value: 'Out of Route Miles' },
  { label: 'Positioning', value: 'Positioning' },
  { label: 'Protective Services', value: 'Protective Services' },
  { label: 'Re-Delivery', value: 'Re-Delivery' },
  { label: 'Roll Back', value: 'Roll Back' },
  { label: 'Route Survey', value: 'Route Survey' },
  { label: 'Storage', value: 'Storage' },
  { label: 'Team Service', value: 'Team Service' },
  { label: 'TONU', value: 'TONU' },
  {
    label: 'Fees',
    value: 'Fees',
    disabled: true,
  },
  { label: 'Bonus', value: 'Bonus' },
  { label: 'Check Call', value: 'Check Call' },
  { label: 'Drop Trailer', value: 'Drop Trailer' },
  { label: 'Fee', value: 'Fee' },
  { label: 'Fine', value: 'Fine' },
  { label: 'GPS Tracking', value: 'GPS Tracking' },
  { label: 'Interstate/Highway Toll', value: 'Interstate/Highway Toll' },
  { label: 'Late Fee', value: 'Late Fee' },
  { label: 'New York Delivery Charge', value: 'New York Delivery Charge' },
  { label: 'On-time Delivery', value: 'On-time Delivery' },
  { label: 'On-time Pick Up', value: 'On-time Pick Up' },
  { label: 'Over Weight', value: 'Over Weight' },
  { label: 'Pallet Charge', value: 'Pallet Charge' },
  { label: 'Premium Charge', value: 'Premium Charge' },
  { label: 'Special Handling Service', value: 'Special Handling Service' },
  { label: 'Tarp Fee', value: 'Tarp Fee' },
  { label: 'Unloading', value: 'Unloading' },
  {
    label: 'Intermodal',
    value: 'Intermodal',
    disabled: true,
  },
  { label: 'Block And Brace', value: 'Block And Brace' },
  { label: 'Chassis', value: 'Chassis' },
  { label: 'Diversion', value: 'Diversion' },
  { label: 'Driver Assist', value: 'Driver Assist' },
  { label: 'Driver Count', value: 'Driver Count' },
  { label: 'Driver Dunnage Disposal', value: 'Driver Dunnage Disposal' },
  { label: 'Driver Layover', value: 'Driver Layover' },
  { label: 'Driver Sweep', value: 'Driver Sweep' },
  { label: 'Driver Wash Out', value: 'Driver Wash Out' },
  {
    label: 'Dry Run (TONU) Equipment Not Used',
    value: 'Dry Run (TONU) Equipment Not Used',
  },
  { label: 'Hazmat', value: 'Hazmat' },
  { label: 'High Value Seal Charge', value: 'High Value Seal Charge' },
  { label: 'Lumper Loading', value: 'Lumper Loading' },
  { label: 'Lumper Unloading', value: 'Lumper Unloading' },
  { label: 'Miscellaneous', value: 'Miscellaneous' },
  { label: 'Night Delivery', value: 'Night Delivery' },
  { label: 'Pier Pass', value: 'Pier Pass' },
  {
    label: 'Power Detention Drop and Hook',
    value: 'Power Detention Drop and Hook',
  },
  {
    label: 'Power Detention Live Unload',
    value: 'Power Detention Live Unload',
  },
  { label: 'Pre-Pull', value: 'Pre-Pull' },
  { label: 'Reconsignment', value: 'Reconsignment' },
  { label: 'Scale Light and Heavy', value: 'Scale Light and Heavy' },
  { label: 'Single Scale Charge', value: 'Single Scale Charge' },
  { label: 'Stop Off', value: 'Stop Off' },
  { label: 'Tri-Axle', value: 'Tri-Axle' },
  { label: 'Yard Pull', value: 'Yard Pull' },
  { label: 'Yard Storage', value: 'Yard Storage' },
  {
    label: 'LTL',
    value: 'LTL',
    disabled: true,
  },
  { label: 'Additional Freight', value: 'Additional Freight' },
  { label: 'Agent Authorized SED', value: 'Agent Authorized SED' },
  { label: 'Airport Delivery', value: 'Airport Delivery' },
  { label: 'Airport Pickup', value: 'Airport Pickup' },
  { label: 'Appointment Delivery', value: 'Appointment Delivery' },
  { label: 'Appointment Pickup', value: 'Appointment Pickup' },
  { label: 'Bill of Lading', value: 'Bill of Lading' },
  { label: 'Blind Shipment', value: 'Blind Shipment' },
  { label: 'CarrierCharge', value: 'CarrierCharge' },
  { label: 'CFS Delivery', value: 'CFS Delivery' },
  { label: 'CFS Pickup', value: 'CFS Pickup' },
  { label: 'Clean Air Surcharge', value: 'Clean Air Surcharge' },
  { label: 'COI Required', value: 'COI Required' },
  { label: 'Correction of Terms', value: 'Correction of Terms' },
  { label: 'Cubic Capacity', value: 'Cubic Capacity' },
  { label: 'Dimensional Weight', value: 'Dimensional Weight' },
  { label: 'Discount', value: 'Discount' },
  { label: 'Gate Fee', value: 'Gate Fee' },
  { label: 'Ground Delivery Service', value: 'Ground Delivery Service' },
  { label: 'Guaranteed Delivery Day', value: 'Guaranteed Delivery Day' },
  { label: 'Handling Fee', value: 'Handling Fee' },
  { label: 'High Cost Area Fee', value: 'High Cost Area Fee' },
  { label: 'Inspection Fee', value: 'Inspection Fee' },
  { label: 'Inside Delivery', value: 'Inside Delivery' },
  { label: 'Inside Pickup', value: 'Inside Pickup' },
  { label: 'Labeling', value: 'Labeling' },
  { label: 'Labor', value: 'Labor' },
  { label: 'Liftgate Delivery', value: 'Liftgate Delivery' },
  { label: 'Liftgate Pickup', value: 'Liftgate Pickup' },
  { label: 'Limited Access Delivery', value: 'Limited Access Delivery' },
  { label: 'Limited Access Pickup', value: 'Limited Access Pickup' },
  { label: 'LOA', value: 'LOA' },
  { label: 'Notification Delivery', value: 'Notification Delivery' },
  { label: 'Protect From Freeze', value: 'Protect From Freeze' },
  { label: 'Redelivery', value: 'Redelivery' },
  { label: 'Re-Class', value: 'Re-Class' },
  { label: 'Residential Delivery', value: 'Residential Delivery' },
  { label: 'Residential Pickup', value: 'Residential Pickup' },
  { label: 'Reweigh Fee', value: 'Reweigh Fee' },
  { label: 'Saturday Pickup', value: 'Saturday Pickup' },
  { label: 'Seal', value: 'Seal' },
  { label: 'Sort & Segregate', value: 'Sort & Segregate' },
  { label: 'Sort & Segregate Delivery', value: 'Sort & Segregate Delivery' },
  { label: 'Sort & Segregate Pickup', value: 'Sort & Segregate Pickup' },
  { label: 'Tarp', value: 'Tarp' },
  { label: 'Trade Show Delivery', value: 'Trade Show Delivery' },
  { label: 'Trade Show Pickup', value: 'Trade Show Pickup' },
  { label: 'Warehouse Fee', value: 'Warehouse Fee' },
  { label: 'White Glove Service', value: 'White Glove Service' },
  {
    label: 'Misc',
    value: 'Misc',
    disabled: true,
  },
  { label: 'Adjustment', value: 'Adjustment' },
  { label: 'GST/HST', value: 'GST/HST' },
  { label: 'LTL Insurance', value: 'LTL Insurance' },
  { label: 'Misc', value: 'Misc' },
  { label: 'Paid Wrong Carrier', value: 'Paid Wrong Carrier' },
  { label: 'Short Pay', value: 'Short Pay' },
  { label: 'Write Off', value: 'Write Off' },
];
/*eslint-disable */
export const reeferEquipmentTypes = [
  "R, Reefer",
  "Reefer",
  "R53, 53' Reefer",
  "R53, 53 'Reefer",
  "RA, Reefer with Air ride",
  "R2, Reefer Double",
  "R26, 26' Reefer",
];
/*eslint-enable */

export const fuelCharges = [
  'Spot Charge',
  'Line Haul',
  'Rate per Mile',
  'Rate per Pound',
  'Rate per Unit',
];

export const CARRIER_TOTAL_EXCEEDS_MAX_RATE_MESSAGE =
  'Cannot save carrier charges when carrier total is greater than max rate. Please submit offer for approval.';

export const CARRIER_TOTAL_EXCEEDS_MAX_RATE_BOOKED_MESSAGE =
  'Cannot save carrier charges when carrier total is greater than max rate. Request max rate increase.';

export const MAX_RATE_BOOKED_STATUSES = [
  'Assigned',
  'Dispatched',
  'At Shipper',
  'Loaded',
  'In Transit',
  'Out On Delivery',
  'At Receiver',
  'Empty',
];

export const DEFAULT_NEW_ORDER_LOAD_TRACKING_REQUEST: ILoadEditViewModel['loadTrackingRequest'] =
  {
    loadId: 0,
    carrierId: 0,
    trackingStopWindows: [],
    eldAssetId: '',
    minTemp: null,
    maxTemp: null,
    unitOfMeasure: '',
    email: null,
    trackingEmail: null,
    trackingStartDateTime: null,
    shipperEmail: '',
    brokerEmail: '',
    carrierDispatchEmail: '',
    trackingFrequency: 0,
    shipperLink: null,
  };

export const DEFAULT_NEW_ORDER_LOAD = {
  operationType: 'Insert',
  id: 0,
  editable: false,
  orderId: 0,
  sequence: 0,
  carrierId: null,
  carrierActionPlan: false,
  carrierMC: '',
  teamRequired: false,
  hazmatRequired: false,
  tarpRequired: false,
  billingHold: false,
  trackingEnabled: false,
  enableTracking: false,
  od: false,
  freightValue: undefined,
  weight: 0,
  canRate: false,
  synched: false,
  edi: false,
  postingId: null,
  signedRateCon: false,
  customerId: 0,
  ramps: false,
  canVoidLoad: false,
  assignedId: 0,
  claim: null,
  loadInformation: undefined,

  // Below are all optional properties.
  // If these properties have meaningful default values in your real-world application,
  // you can replace 'undefined' with those values.
  loadTrackingRequest: DEFAULT_NEW_ORDER_LOAD_TRACKING_REQUEST,
  warnings: undefined,
  loadNum: undefined,
  status: 'Unassigned',
  useStatusStateMachine: true,
  type: undefined,
  customerReferenceNumber: undefined,
  coveredById: undefined,
  coveredBy: undefined,
  carrierName: undefined,
  carrierStatus: undefined,
  carrierContactId: undefined,
  equipment: undefined,
  mode: undefined,
  carrierInstructions: undefined,
  terminal: undefined,
  practicalMileage: undefined,
  shortestMileage: undefined,
  driver: undefined,
  driverPhoneNumber: undefined,
  truckNumber: undefined,
  trailerNumber: undefined,
  vinNumber: undefined,
  trackingNumber: undefined,
  product: undefined,
  tempInstructions: undefined,
  billingHoldReason: undefined,
  billingHoldDescription: undefined,
  billedDate: undefined,
  paidDate: undefined,
  assignedToUserId: undefined,
  assignedToGroupId: undefined,
  assignedToUser: undefined,
  assignedToGroup: undefined,
  assignedToOffice: undefined,
  legalText: undefined,
  profitSplit: undefined,
  sharedWithOfficeId: undefined,
  nmfc: undefined,
  marketRate: undefined,
  class: undefined,
  minPrice: undefined,
  maxPrice: undefined,
  lastInternalNote: undefined,
  signedConfirmationDate: undefined,
  macropointInterval: undefined,
  quoteId: undefined,
  ltlSubCarrier: undefined,
  tenderedToTransfloDate: undefined,
  currencyType: undefined,
  cargoValueIsHigh: undefined,
  owner: undefined,
  carrierContact: undefined,
  ltlQuote: undefined,
  lineItems: undefined,
  payments: undefined,
  stops: undefined,
  comments: undefined,
  flags: undefined,
  items: undefined,
  quoteID: undefined,
  ltlquoteId: undefined,
  newLtlQuoteId: null,
  hideCustomerName: false,
  hasBeenSharedWithCapacity: false,
  enableLoadCarrierRestrictionOverride: false,
  enableLoadCarrierRestrictionOverrideOffice: null,
};

export const DEFAULT_ORDER_STATE: Omit<IOrderViewModel, 'loads' | 'orderRep'> =
  {
    pointOfSaleInstructions: null,
    availableServices: [],
    customerId: null,
    currencyType: '',
    referenceNumber: '',
    assignedId: 0,
    status: 'Open',
    bidType: '',
    owner: '',
    exceptionReason: '',
    customerContactId: undefined,
    revisitRetractionDate: '',
    lineItems: [],
    payments: [],
    adjustments: [],
    vendors: [],
    operationType: 'Insert',
    id: 0,
    chargeCreditCardFee: false,
    customerCredit: 0,
    billingHold: false,
    agingOut: false,
    editable: false,
    synched: false,
    private: false,
    edi: false,
    trackLoads: false,
    show214: false,
    daysPastDue: 0,
    canVoidOrder: false,
    createdDate: new Date(Date.now()),
    createdBy: 0,
    isDeleted: false,
    loadInformation: undefined,
    metadata: [],
    hideCustomerName: false,
    spotId: undefined,
    spotQuote: undefined,
    holdRetraction: undefined,
    operationsId: null,
    operationsRep: null,
  };

export const defaultFeatureFlagCustomerState = {
  CustomerCommentVisibility: false,
  suggestedClass: false,
  EDIDropoffDriverInAuto214: false,
  EDIDropoffDriverOutAuto214: false,
  EDIDropoffAppointmentAuto214: false,
  EDIPickupDriverInAuto214: false,
  EDIPickupDriverOutAuto214: false,
  EDIPickupAppointmentAuto214: false,
  TruckerTools: false,
  TruckerToolsEldAssetApi: false,
  QuoteLoadItemBreakdown: false,
  LtlCarrierBlockInclude: false,
  LtlQuoteExpiration: false,
};

export const COUNTRY_MAP: Record<string, string> = {
  US: 'USA',
  USA: 'USA',
  'United States': 'USA',
  CA: 'CAN',
  CAN: 'CAN',
  Canada: 'CAN',
  MX: 'MEX',
  MEX: 'MEX',
  Mexico: 'MEX',
};
